module.exports = __webpack_public_path__ + "img/48.8ef0b6e6.gif";